Namespace.create("cv.Views.Team.Setup").AppealView = Marionette.LayoutView.extend({
  className: "view-team-setup-appeal",

  template: cv.Templates["team/setup/appeal/view"],

  behaviors: [
    {
      behaviorClass: cv.FormBehavior,
    },
  ],

  regions: {
    region_appeal: "#region-appeal",
  },

  events: {},

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    this.listenTo(
      this,
      "form:saved",
      function () {
        vent.trigger("setup:next_screen");
      },
      this,
    );

    // If save button is clicked and it's valid, we copy over the draft to appeal
    this.listenTo(
      this,
      "form:validated",
      function () {
        this.trigger("form:set", "description", this._model_clone.get("draft"));
      },
      this,
    );

    console.log("TeamSetupAppealView initialized");
  },

  templateHelpers: function () {
    return {};
  },

  onAttach: function () {
    // Change document title
    document.title = "Team Setup | Write your Team Appeal";
  },

  onShow: function () {
    // Default appeals
    var view = new cv.Views.VueComponentView({
      component: "BaseRichText",
      defaultArgs: {
        props: {
          name: "Enter content...",
          value: this._model_clone.get("draft"),
        },
      },
    });
    view.on(
      "value_changed",
      function (val) {
        this._model_clone.set("draft", val);

        // Save the draft
        $.ajax({
          url: this.model.url(),
          data: {
            draft: val,
          },
          dataType: "json",
          type: "PUT",
          success: _.bind(function (data) {}, this),
          error: _.bind(function (data) {}, this),
        });
      },
      this,
    );
    this.showChildView("region_appeal", view);

    this.model.fetch({
      success: _.bind(function () {
        view.trigger("set_value", "value", this.model.get("draft"));
      }, this),
    });
  },

  onDestroy: function () {},
});
